import type { Fetcher } from "react-query-kit";
import { createQuery } from "react-query-kit";

import type { IPickSingleQuery } from "../types";
import { getApi } from "../apiPath";
import { axiosClient } from "../clients";

import type { IUsers } from "./routeType";

const { key, getPath } = getApi("users.me.get");

type IExtractedRouteType = IUsers["userProfileSingleRetrieve"];

export type IGetProfile = IPickSingleQuery<IExtractedRouteType>;

const getUser: Fetcher<IGetProfile["response"], IGetProfile["variables"]> = (
  params,
) => {
  return axiosClient.get(getPath(), { params });
};

export const useGetProfile = createQuery({
  queryKey: [key],
  fetcher: getUser,
});
